import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { UserService } from '../service/user.service';
import { Log } from '../util/log';
import { DeviceService } from '../service/device.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-add-device',
  templateUrl: './add-device.component.html',
  styleUrls: ['./add-device.component.css']
})
export class AddDeviceComponent implements OnInit, AfterViewInit {

  @ViewChild('loader', { static: true }) loader;

  authCode: string;

  serial: string;
  productionDateEpoch: number;
  productionDate: string;
  productionDateDate: Date;
  version: number;
  systemOptions: number;
  name: string;
  model: string;
  reference: string;
  city: string;
  address: string;

  addDeviceForm = new FormGroup({
    name: new FormControl(''),
    date: new FormControl(''),
    model: new FormControl(''),
    reference: new FormControl(''),
    city: new FormControl(''),
    address: new FormControl('')
  });

  constructor(private userService: UserService, private deviceService: DeviceService) {

  }

  ngOnInit() {
  }

  printStuff() {
    Log.debug("Stuff to print: " + this.name + ' ' + this.model);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // this.getAuthCode();
    });
  }
}
